'use client';
import 'rsuite/dist/rsuite-no-reset.css';
import '@/css/rsuite.css';
import '@/css/satoshi.css';
import '@/css/style.css';
import '@/css/big-calendar.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { GoogleAnalytics } from '@next/third-parties/google';
import { CustomProvider } from 'rsuite';
import { SocketProvider } from '@/lib/socket/SocketProvider';
import AuthProvider from '@/components/auth/AuthProvider';
import { Analytics } from '@vercel/analytics/next';

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="es" translate="no">
      <head>
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link
          rel="manifest"
          crossOrigin="use-credentials"
          href="/site.webmanifest"
        />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="theme-color" content="#ffffff" />
        <title>Meissa</title>
      </head>
      <body suppressHydrationWarning={true}>
        <div className="dark:bg-boxdark-2 dark:text-bodydark">
          <AuthProvider>
            <QueryClientProvider client={new QueryClient()}>
              <CustomProvider>
                <SocketProvider>{children}</SocketProvider>
              </CustomProvider>
            </QueryClientProvider>
          </AuthProvider>
        </div>
        <Analytics />
        <GoogleAnalytics
          gaId={process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID ?? ''}
        />
      </body>
    </html>
  );
}
